import React, { useEffect } from "react"

import { Container, Table, Th, Tbody, Td, CreatorContainer, PerfilImg, Icon, PlatformContainer, LabelContainer, MetricCardsContainer, MetricCard, MetricCardText, MetricCardValue } from "./styled"


const MAPPER_ICONS = {
    "instagram": "/icons/insta-color.svg",
    "youtube": "/icons/galery-color.svg",
    "tiktok": "/icons/tiktok-color.svg",
}


export default function CreatorsTable({ postUrl, data }) {
    function formatNumber(num) {
        if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(1).replace('.0', '') + 'M';
        }

        if (num >= 1_000) {
            return (num / 1_000).toFixed(1).replace('.0', '') + 'K';
        }

        return num?.toString();
    }

    return (
        <Container>
            <MetricCards
                data={[
                    {
                        text: "Publicações",
                        value: formatNumber(data?.totals?.amountPost)
                    },
                    {
                        text: "Reels",
                        value: formatNumber(data?.totals?.amountReel)
                    },
                    {
                        text: "Videos",
                        value: formatNumber(data?.totals?.amountVideo)
                    },
                    {
                        text: "Stories",
                        value: 0
                    }
                ]}
            />

            <Table id="table">
                <thead>
                    <tr>
                        <Th style={{ paddingLeft: "30px", textAlign: "left" }}>
                            Creator
                        </Th>
                        <Th >
                            Plataformas
                        </Th>
                        <Th>
                            ER
                        </Th>
                        <Th
                        >
                            Impressões
                        </Th>
                        <Th >
                            Visualizações
                        </Th>

                        <Th style={{ paddingRight: "30px" }}>Compartilhamentos</Th>
                    </tr>
                </thead>
                <Tbody>

                    {
                        data?.data?.map((item, index) =>
                            <tr key={index}>
                                <Td style={{ paddingLeft: "30px" }}>
                                    <CreatorContainer>

                                        <PerfilImg
                                            src={item.creator_image_url}
                                        />
                                        <p>{item.creator_name}</p>
                                    </CreatorContainer>
                                </Td>

                                <Td >
                                    <PlatformContainer>
                                        <Icon src={MAPPER_ICONS[item?.platform]} />
                                        <p style={{ width: 58 }}>{item.platform}</p>
                                    </PlatformContainer>
                                </Td>

                                <Td >
                                    <Label text={`${item?.engagement_rate.toFixed(2)}%`} />
                                </Td>

                                <Td >
                                    {formatNumber(item?.impressions)}
                                </Td>

                                <Td >
                                    {formatNumber(item?.views)}
                                </Td>
                                <Td style={{ paddingRight: "30px" }}>
                                    {item.shares}
                                </Td>
                            </tr>
                        )}
                </Tbody>
            </Table>
        </Container>
    )
}


function Label({ text }) {
    return (
        <LabelContainer>
            {text}
        </LabelContainer>
    );
}

function MetricCards({ data }) {
    return (
        <MetricCardsContainer>
            {data.map((item, index) => (
                <MetricCard key={index}>
                    <MetricCardText>
                        {item.text}
                    </MetricCardText>
                    <MetricCardValue>
                        {item.value}
                    </MetricCardValue>
                </MetricCard>
            )
            )}
        </MetricCardsContainer>
    );
}